import { common } from "../../config/style-configs/common";

export const styles = {
  listRefreshButton: common.listRefreshButton
};
